import { StrictMode, startTransition } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { StartClient } from '@tanstack/react-start/client'
import { SPA_SHELL_ATTRIBUTE, markShellRendered } from '~/lib/site/spa-shell'

// Start's default client entry, except that the SPA shell is rendered rather
// than hydrated. /_shell.html is prerendered for the masked path `/?spa-shell`
// and served by the CDN for any path that wasn't prerendered, so the client
// URL is a different page than the one in the HTML (another active nav link,
// the not-found page or a still-loading route instead of the pending
// fallback, the home page's head tags). Hydrating that is a guaranteed
// mismatch: React logs error #418 and throws the server markup away anyway.
// Rendering directly gives the same result without the error.
const app = (
  <StrictMode>
    <StartClient />
  </StrictMode>
)

startTransition(() => {
  if (document.documentElement.hasAttribute(SPA_SHELL_ATTRIBUTE)) {
    // React keeps <script> nodes it didn't render, so the home page's JSON-LD
    // in the shell would stay on every page and be doubled on /.
    for (const script of document.head.querySelectorAll(
      'script[type="application/ld+json"]',
    ))
      script.remove()
    markShellRendered()
    createRoot(document).render(app)
  } else hydrateRoot(document, app)
})
